import '../sass/embed.sass';

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from './store';
import CoverageMap from './apps/infrastructure/coverage-map.vue';
import settings from "./settings";

const DEBUG = false;

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: settings.LANGUAGE_CODE || 'en'
});

$(() => {
  console.debug('initialize embed view');
  const coverage_map_container = document.getElementById('coverage_map');
  if (coverage_map_container) {
    if (DEBUG) console.debug('initialize coverage map', coverage_map_container.dataset);
    const CoverageMapComponent = Vue.extend(CoverageMap);
    new CoverageMapComponent({
      el: coverage_map_container,
      store,
      i18n,
      propsData: coverage_map_container.dataset
    });
  }
  document.addEventListener("navigate:to", (e) => {
    // document.location.href = e.detail.url;
    window.open(e.detail.url, '_blank');
  });
});
